import React from 'react';
import HTMLReactParser from 'html-react-parser';
import { Link } from 'react-router-dom';

function ReportTile({ report = {} }) {
  let toLink = `/analytics/${report.type}/?rid=${report.id}&gid=${report.gid}&aws=${report.aws}`;
  if (report.useStatePerms) toLink += '&statePerms=1';
  return (
    <div
      className="col-md-8 mb-3 bg-white p-3"
      style={{
        border: 'solid 1px lightgrey',
        borderRadius: '3px',
        boxShadow: '0px 0px 3px 0px lightgrey',
      }}
    >
      <Link
        to={toLink}
        className="text-black text-decoration-none"
      >

        <div className="d-flex justify-content-between mb-3">
          <div className="">
            <h5 className="m-0">{report.name}</h5>
          </div>
          <div className="">
            <span className="fs-4">{report.year}</span>
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <i>{HTMLReactParser(report.description)}</i>
        </div>

      </Link>
    </div>
  );
}

export default ReportTile;
